module.exports = __webpack_public_path__ + "static/media/CERN.9fbbfc4c.png";